import React from "react";
import Select from "react-select";

// Generic type-to-filter dropdown, same react-select usage already
// established by ProjectMemberPicker.jsx -- used for plain lookup lists
// (task type, priority, department, project, category, ...) where the
// caller just needs {value, label} options and a single selected value,
// as a drop-in replacement for a native <Form.Select> that doesn't
// support typing to filter long lists.
export default function SearchableSelect({
  options = [],
  value,
  onChange,
  placeholder = "Select...",
  isDisabled = false,
  isClearable = true,
  isLoading = false,
  // Optional form-accessibility hooks (all default to "not passed", so every
  // existing caller renders exactly as before): `inputId` lets a <label
  // htmlFor> target the search input, `onBlur` drives blur-time validation,
  // and `isInvalid`/`errorId` expose the invalid state + its message.
  inputId,
  onBlur,
  isInvalid = false,
  errorId,
}) {
  const selected = options.find((o) => String(o.value) === String(value ?? "")) || null;

  return (
    <Select
      classNamePrefix="member-picker"
      className={isInvalid ? "member-picker-invalid" : undefined}
      inputId={inputId}
      onBlur={onBlur}
      aria-invalid={isInvalid ? true : undefined}
      aria-errormessage={isInvalid ? errorId : undefined}
      options={options}
      value={selected}
      onChange={(opt) => onChange(opt ? opt.value : "")}
      placeholder={placeholder}
      isClearable={isClearable}
      isDisabled={isDisabled}
      isLoading={isLoading}
      noOptionsMessage={() => "No options found"}
      menuPortalTarget={typeof document !== "undefined" ? document.body : null}
      // Bootstrap <Modal> in this app renders at z-index 1320 (see
      // src/index.css) -- portaling the menu to document.body escapes the
      // Modal's own overflow/stacking context (the bug this component
      // exists to fix, e.g. the "Staff / User" picker's menu rendering
      // clipped past the modal's edge), and this z-index keeps it above
      // that modal layer regardless of which page/modal it's used in.
      styles={{ menuPortal: (base) => ({ ...base, zIndex: 1400 }) }}
    />
  );
}
